export const WELLSFARGOURL = "https://oam.wellsfargo.com/oamo/identity/enroll/enrollment#/";
export const MYVWAPP_SOURCE = "myVWApp";
